export function layoutConfigs (isChina) {
  return isChina ? {
    showMainNav: false,
    showAuth: false,
    showFooter: false,
    showShortcuts: false,
  } : {}
}
